import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Button, Form } from 'react-bootstrap';
import { hasAcceptedEula, acceptEula } from '../../logic/eula/eulaAcceptance';
import EulaDocument from './EulaDocument';
import './EulaGate.css';

// App-wide gate. Blocks interaction with the rest of the app until the signed-in
// user has accepted the current EULA version. Re-prompts automatically after a
// version bump, even for users who are already signed in and previously accepted
// an older version. Mounted around the authed shell in the Layout, so it only
// applies once a user exists.
const EulaGate = ({ children }) => {
  const user = useSelector((state) => state?.auth?.user);
  const userId = user?.id;

  const [accepted, setAccepted] = useState(true);
  const [acknowledged, setAcknowledged] = useState(false);

  // Re-evaluate acceptance whenever the user changes (login/logout/version bump).
  useEffect(() => {
    if (!user) {
      setAccepted(true); // no gate until someone is signed in
      return;
    }
    setAccepted(hasAcceptedEula(userId));
    setAcknowledged(false);
  }, [user, userId]);

  if (!user || accepted) return <>{children}</>;

  return (
    <>
      {children}
      <Modal
        show
        centered
        scrollable
        backdrop="static"
        keyboard={false}
        size="lg"
        aria-labelledby="eula-title"
        contentClassName="eula-modal"
      >
        <Modal.Header>
          <Modal.Title id="eula-title">End User License Agreement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EulaDocument />
        </Modal.Body>
        <Modal.Footer className="eula-footer">
          <Form.Check
            type="checkbox"
            id="eula-acknowledge"
            className="eula-check"
            label="I have read and agree to the End User License Agreement"
            checked={acknowledged}
            onChange={(e) => setAcknowledged(e.target.checked)}
          />
          <Button
            variant="primary"
            className="eula-agree"
            disabled={!acknowledged}
            onClick={() => {
              acceptEula(userId);
              setAccepted(true);
            }}
          >
            I Agree
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EulaGate;
